import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelect from '../../ReactSelect/ReactSelect';
import { FormGroup, Input } from 'ps-design';

export default class Education extends Component {
  static propTypes = {
    saveJobAndUpdatePay: PropTypes.func,
    display: PropTypes.bool,
    highestDegreeEarned: PropTypes.string,
    majorSpecialty: PropTypes.string,
    orgJobTitle: PropTypes.string,
    jobCode: PropTypes.string,
    workLocationExact: PropTypes.string,
    orgJobId: PropTypes.number,
    highestDegreeEarnedList: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    )
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      highest_degree: this.props.highestDegreeEarned,
      major_specialty: this.props.majorSpecialty
    };
  }

  educationChange(value) {
    const jobDetails = {};
    if (value) {
      this.setState({ highest_degree: value.value });
      jobDetails.HighestDegreeEarned = value.value;
    } else {
      this.setState({ highest_degree: value });
      jobDetails.HighestDegreeEarned = '';
    }

    this.props.saveJobAndUpdatePay(
      {
        orgJobTitle: this.props.orgJobTitle,
        orgJobCode: this.props.jobCode,
        workLocation: this.props.workLocationExact,
        orgJobId: this.props.orgJobId,
        jobDetails: jobDetails
      },
      {
        HighestDegreeEarned: jobDetails.HighestDegreeEarned
      }
    );
  }

  handleMajorChange = (field, value) => {
    if (value) {
      this.setState({ major_specialty: value });
    } else {
      this.setState({ major_specialty: '' });
    }
  };

  handleMajorBlur(value) {
    if (this.state.major_specialty === this.props.majorSpecialty) {
      return;
    }

    const jobDetails = {};
    jobDetails.MajorSpecialty = this.state.major_specialty;
    this.props.saveJobAndUpdatePay(
      {
        orgJobTitle: this.props.orgJobTitle,
        orgJobCode: this.props.jobCode,
        workLocation: this.props.workLocationExact,
        orgJobId: this.props.orgJobId,
        jobDetails: jobDetails
      },
      {
        MajorSpecialty: jobDetails.MajorSpecialty
      }
    );
  }

  getValue(option) {
    return option.value;
  }

  getLabel(option) {
    return option.value;
  }

  render() {
    const { display, highestDegreeEarnedList, isMP } = this.props;
    if (display && display !== true) {
      return;
    }

    return (
      <div className="row add-job__education">
        <div className="col-sm-8 add-job__education__column">
          {!isMP && (
            <h3 className="add-job__all-headers">
              <i className="add-job__experience-heading-icon icon-graduation-cap" />
              Education
            </h3>
          )}
          <FormGroup
            text="Highest Degree Earned"
            labelClassName="add-job__form-headers"
            className="col-sm-6 add-job__education__form-container"
          >
            <ReactSelect
              value={highestDegreeEarnedList?.filter?.(({ value }) => value === this.state.highest_degree)}
              options={highestDegreeEarnedList}
              getOptionValue={this.getValue.bind(this)}
              getOptionLabel={this.getLabel.bind(this)}
              onChange={this.educationChange.bind(this)}
              isClearable={true}
            />
          </FormGroup>
          <FormGroup
            text="Major Specialty"
            labelClassName="add-job__form-headers"
            className="col-sm-6 add-job__education__form-major"
          >
            <Input
              type="text"
              value={this.state.major_specialty}
              onChange={this.handleMajorChange}
              onBlur={this.handleMajorBlur.bind(this)}
            />
          </FormGroup>
        </div>
      </div>
    );
  }
}
